module.exports = __webpack_public_path__ + "static/daws-b1c1f136154a68e6be8081a350f775e5.png";